module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Archiving Project","introduction":["You are about to archive the Project “{name}”. It will still work as it does now, but it will be sorted to the bottom of the Project List on the Central homepage.",{"full":"{noUndo}, but the ability to unarchive a Project is planned for a future release.","noUndo":"This action cannot be undone"}]}}')
  delete Component.options._Ctor
}
